"use client";

import AccordionItemBlok from "@/components/blocks/sections/Accordion/AccordionItem";
import { AccordionRoot } from "@/components/ui/Accordion";
import DangerouslySetHtmlContent from "@/components/ui/InnerHTML";
import Price from "@/features/product/components/Price";
import { ProductPageStoryblok } from "@/lib/types/storyblok-blok-types";
import { useProductContext } from "../../ProductProvider";
import styles from "./index.module.css";

interface Props {
  accordion?: ProductPageStoryblok["accordion"];
}

const ProductInformation = ({ accordion }: Props) => {
  const { activeVariant } = useProductContext();

  return (
    <section className={styles.root}>
      <div className={styles.wrapper}>
        <h1 className={styles.title}>{activeVariant?.name}</h1>
        <Price
          isSalePrice={!!activeVariant?.isSalePrice}
          prices={activeVariant?.prices}
          className={styles.price}
        />
        {activeVariant?.shortDescription && (
          <div className={styles.lead}>
            <DangerouslySetHtmlContent
              html={activeVariant.shortDescription}
              type="html"
            />
          </div>
        )}
        <div className={styles.accordion}>
          <AccordionRoot>
            {accordion?.map(item => (
              <AccordionItemBlok item={item} key={item._uid} />
            ))}
          </AccordionRoot>
        </div>
      </div>
    </section>
  );
};

export default ProductInformation;
